import React from 'react'
import PropTypes from 'prop-types'
import {TAB_COMMENTS} from '../../state/detail/const'
import NewProcessComment from './tab-comments/NewProcessComment'
import ProcessCommentList from './tab-comments/ProcessCommentList'


const TabComments = (props) => {
    const {tab} = props
    if (tab !== TAB_COMMENTS) {
        return null
    }
    return (

        <React.Fragment>

            <ProcessCommentList
                findProcessCommentList={props.findProcessCommentList}
                processInstanceList={props.processInstanceList}
            />

            <NewProcessComment {...props} />

        </React.Fragment>

    )
}

TabComments.propTypes = {
    tab: PropTypes.string.isRequired,
    findProcessCommentList: PropTypes.func.isRequired,
    processInstanceList: PropTypes.array,
}

export default TabComments



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/TabComments.js